import React, {useEffect} from 'react';
export const useEffectKeys = ({subSequence, setSelectedPadEdge}) => {
    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, []);

    const onKeyDown = (e) => {
        if (e.key === "Backspace") {
            let {sequencerEngine} = subSequence;
            let {selectedEdge} = sequencerEngine.state.pads;
            if (selectedEdge) {
                let pad = subSequence.pads.find(
                    pad => pad.effectRack.effects.includes(selectedEdge.effect) ||
                        pad.effectRack.outputNode === selectedEdge.effect);
                if (!pad) {
                    // look for track
                    pad = subSequence.tracks.find(
                        track => track.effectRack &&
                            (track.effectRack.effects.includes(selectedEdge.effect) ||
                             track.effectRack.outputNode === selectedEdge.effect));
                }
                pad.effectRack.deleteEdge(selectedEdge);
                setSelectedPadEdge(undefined);
            }
        }
    };
};
